export default "__VITE_ASSET__C5vhX$HN__"